import { Driver } from '../../common/models/Driver';
import { DriverResponse } from '../models/responses/DriverResponse';
import { LicenseMapper } from './LicenseMapper';
import { UserMapper } from './UserMapper';
import { VehicleMapper } from './VehicleMapper';

export const DriverMapper = (data: DriverResponse): Driver => {
  return {
    id: data._id,
    birthday: data.birthday,
    ci: data.ci,
    licenses: data.licences.map((license) => LicenseMapper(license)),
    photo: data.photo,
    user: UserMapper(data.userDetails),
    vehicle: VehicleMapper({
      ...data.vehicleDetails,
      vehicleType: data.vehicleTypeDetails,
    }),
  };
};
